import { render, staticRenderFns } from "./classparametersSJZ.vue?vue&type=template&id=174be827"
import script from "./classparametersSJZ.vue?vue&type=script&lang=js"
export * from "./classparametersSJZ.vue?vue&type=script&lang=js"
import style1 from "./classparametersSJZ.vue?vue&type=style&index=1&id=174be827&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports